import { render, staticRenderFns } from "./ClientReports.vue?vue&type=template&id=ab4b7172&"
import script from "./ClientReports.vue?vue&type=script&lang=js&"
export * from "./ClientReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports